"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.className = void 0;
/**
 * Combine strings and/or objects if values are truthy into a single space delimited string.
 *
 * @example
 * className('test', { visible: true, hidden: false });
 * // 'test visible'
 *
 * @param params Parameters to check and combine.
 */
function className(...params) {
    const res = [];
    for (let param of params) {
        if (typeof param === 'string') {
            res.push(param);
        }
        else if (typeof param === 'object') {
            const keys = Object.keys(param).filter(key => param[key]);
            if (keys.length) {
                res.push(...keys);
            }
        }
    }
    return res.join(' ');
}
exports.className = className;
//# sourceMappingURL=className.js.map